import { c as _c } from "react/compiler-runtime";
import { Icon } from "@/components/formatters/MXPIcon";
export interface EmailButton {
  size?: "small" | "medium" | "large";
  label: string;
  emailButtonClickHandler?: () => void;
  emailFieldRef?: any;
}
export const EmailButton = t0 => {
  const $ = _c(15);
  const {
    size: t1,
    label,
    emailButtonClickHandler,
    emailFieldRef
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon className="t2-email-button__search-icon my-3.5 mr-0 ml-3.5 text-black action-dark:text-white" type="t2u-mail" size={16} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = emailFieldRef || null;
  let t4;
  if ($[1] !== label || $[2] !== t3) {
    t4 = <input className="t2-email-button__field border-0 m-2.5 font-bold bg-transparent placeholder:text-black placeholder:uppercase action-dark:text-white action-dark:placeholder:text-white" type="text" placeholder={label} ref={t3} />;
    $[1] = label;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `t2-email-button--${size}`;
  let t6;
  if ($[4] !== t5) {
    t6 = ["t2-email-button rounded-4xl w-[88px] h-[88px] border-0 absolute right-[-10px] top-[-23px] bg-yellow-m10 transition-[background-color,border-color,box-shadow] duration-150 ease-in-out hover:cursor-pointer hover:bg-yellow-m10", t5];
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = t6.join(" ");
  let t8;
  if ($[6] !== emailButtonClickHandler) {
    t8 = () => emailButtonClickHandler();
    $[6] = emailButtonClickHandler;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon className="t2-email-button__submit-icon text-white ml-[21px] action-dark:text-black action-light:text-black" type="t2u-chevron-right" size={36} />;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t7 || $[10] !== t8) {
    t10 = <button className={t7} onClick={t8}>{t9}</button>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t4) {
    t11 = <div className="t2-email-button__wrap m-2.5 border border-black rounded-[25px] inline-flex relative w-[310px]">{t2}{t4}{t10}</div>;
    $[12] = t10;
    $[13] = t4;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
};